<template>
    <div class="com-item globalRnd-module" :class="{ active: isactive == true }" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: W.bgColor || 'transparent',
                color: W.textColor || '#333'
            }">
                <div class="globalRnd-module__inner">
                    <div class="globalRnd-module__left">
                        <div v-if="W.enTitle || W.cnTitle" class="public-module_title">
                            <h2 v-if="W.cnTitle" class="module-cn">{{ W.cnTitle }}</h2>
                            <div v-if="W.enTitle" class="module-en">
                                <p class="module-line"></p>
                                {{ W.enTitle }}
                            </div>
                        </div>
                        <div class="globalRnd-module__desc" v-html="W.describeHtml"></div>

                        <ul v-if="W.locations && W.locations.length" class="globalRnd-module__locations">
                            <li v-for="(loc, idx) in W.locations" :key="'l' + idx" class="globalRnd-module__location">
                                <i class="el-icon-location-outline globalRnd-module__pin"></i>
                                <span class="globalRnd-module__city">{{ loc.city }}</span>
                                <span class="globalRnd-module__type">{{ loc.type }}</span>
                            </li>
                        </ul>
                    </div>

                    <div v-if="W.mapImg" class="globalRnd-module__right">
                        <img :src="W.mapImg" class="globalRnd-module__map" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'globalRnd-module',
    components: {},
    props: {
        index: { type: Number },
        type: { type: String, default: 'preview' },
        isactive: { type: Boolean, default: false },
        phoneWidth: { type: Number, default: 1280 },
        proportion: { type: Number, default: 1 },
        modata: {
            type: Object,
            default: function () {
                return {
                    WName: 'globalRnd',
                    Title: '全球研发合作',
                    MID: 36,
                    ModuleName: 'globalRndModule',
                    WContent: {}
                }
            }
        }
    },
    computed: {
        W: {
            get() { return this.modata.WContent || {} },
            set(val) { this.modata.WContent = val }
        }
    },
    data() {
        return {
            defaultData: {
                bgColor: '',
                textColor: '',
                enTitle: 'QUALITY INSPECTION CENTER',
                cnTitle: '全球研发合作',
                describeHtml: '<p>AES 在全球范围内与各大研究机构、高校及供应商紧密合作，持续推动汽车照明技术创新与应用。</p>',
                locations: [
                    { city: '中国·广州', type: 'AES 总部' },
                    { city: '中国·广州', type: '研发中心' },
                    { city: '中国·广州', type: '改装中心' }
                ],
                mapImg: ""
            }
        }
    },
    mounted() {
        if (!this.modata.WContent) {
            this.$set(this.modata, 'WContent', {})
        }
        this.modata.WContent = Object.assign({}, this.defaultData, this.modata.WContent)
        if (!Array.isArray(this.modata.WContent.locations) || !this.modata.WContent.locations.length) {
            this.$set(this.modata.WContent, 'locations', JSON.parse(JSON.stringify(this.defaultData.locations)))
        }
    },
    methods: {},
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.globalRnd-module {
    margin-bottom: 30px;

    .van-sticky {
        width: 94%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 2% 0;
    }

    .globalRnd-module__inner {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        position: relative;
    }

    .globalRnd-module__left {
        flex: 0 0 38%;
        max-width: 38%;
        box-sizing: border-box;
        padding-right: 4%;
    }

    .globalRnd-module__right {
        flex: 1;
        min-width: 0;
    }

    .globalRnd-module__desc {
        font-size: 14px;
        color: #555;
        line-height: 1.8;
        margin: 16px 0 32px;

        ::v-deep p {
            margin: 0;
            text-indent: 2em;
        }
    }

    .globalRnd-module__locations {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .globalRnd-module__location {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .globalRnd-module__pin {
        color: #e60012;
        font-size: 18px;
        margin-right: 12px;
        flex: none;
    }

    .globalRnd-module__city {
        font-size: 14px;
        color: #333;
        margin-right: 32px;
        flex: none;
    }

    .globalRnd-module__type {
        font-size: 14px;
        color: #555;
    }

    .globalRnd-module__map {
        display: block;
        width: 100%;
        height: auto;
        object-fit: contain;
    }
}

@media screen and (max-width: 768px) {
    .globalRnd-module {
        .globalRnd-module__inner {
            flex-direction: column-reverse;
            padding-top: 80px;
        }

        .globalRnd-module__left {
            flex: 0 0 100%;
            max-width: 100%;
            padding-right: 0;
            margin-bottom: 24px;
        }

        .globalRnd-module__right {
            flex: 0 0 100%;
            width: 100%;
        }

        .public-module_title {
            position: absolute;
            top: 0;
            left: 0;
        }

        .globalRnd-module__desc {
            font-size: 19px;
        }

        .globalRnd-module__pin {
            font-size: 24px;
            margin-right: 10px;
        }

        .globalRnd-module__city {
            font-size: 18px;
            margin-right: 28px;
        }

        .globalRnd-module__type {
            font-size: 18px;
        }


    }
}
</style>